/** Prefer Firestore firstName; never derive a greeting from the email local-part. */
export function getMemberFirstName(options: {
  firstName?: string | null;
  displayName?: string | null;
}): string {
  const first = options.firstName?.trim();
  if (first) return first;

  const display = options.displayName?.trim();
  if (display) return display.split(/\s+/)[0];

  return 'there';
}
